/*
  Payment statuses
*/

export const STATUS_PAYMENT_METHOD_UNKNOWN = -1
export const STATUS_PAYMENT_METHOD_ACCEPTED = 0
export const STATUS_PAYMENT_METHOD_REJECTED = 1

export const STATUS_REFUND_SUCCESS = 'complete'
export const STATUS_REFUND_CANCELED = 'canceled'

export const STATUS_PAYMENT_PENDING = 'pending'
export const STATUS_PAYMENT_SUCCESS = 'complete'
export const STATUS_PAYMENT_WAITING_FOR_CAPTURE = 'waiting_for_capture'
export const STATUS_PAYMENT_CANCELED = 'canceled'
export const STATUS_PAYMENT_RESERVED = 'reserved'

export const PAYMENT_OPERATION_TYPE_PAYMENT = 'payment'
export const PAYMENT_OPERATION_TYPE_REFUND = 'refund'

export const RECEIPT_STATUS_DONE = 'done'
export const RECEIPT_STATUS_WAIT = 'wait'
export const RECEIPT_STATUS_FAIL = 'fail'

export const RECEIPT_TYPE_PREPAYMENT = 'prepayment'
export const RECEIPT_TYPE_FULLPAYMENT = 'fullpayment'
export const RECEIPT_TYPE_PREPAYMENT_REFUND = 'prepaymentrefund'
export const RECEIPT_TYPE_REFUND = 'refund'
